import React, {Component} from 'react'
import {Wrapper, CloseButton, MessageContainer} from './Styled'
import Symbol from 'core/components/Symbol'
import PropTypes from 'prop-types'

class MessengerPopUp extends Component {
  static propTypes = {
    messageObject: PropTypes.object.isRequired,
    redirectTo: PropTypes.string.isRequired
  }

  constructor () {
    super()
    this.state = {
      showPopUp: true,
      instantHide: false
    }
  }

  componentDidMount () {
    setTimeout(() => {
      this.setShow()
    }, 3000)
  }

  componentDidUpdate (prevProps) {
    if (prevProps.messageObject !== this.props.messageObject) {
      if (prevProps.messageObject.messageId !== this.props.messageObject.messageId) {
        if (!this.state.showPopUp) {
          this.setShow()
        }
      }
    }
  }

  setShow () {
    this.setState({
      showPopUp: !this.state.showPopUp,
      instantHide: false
    }, () => {
      if (this.state.showPopUp) {
        setTimeout(() => {
          this.setShow()
        }, 3000)
      }
    })
  }

  instantHide (value) {
    this.setState({
      instantHide: value || !this.state.instantHide
    })
  }

  render () {
    const {sender, message, channelUrl} = this.props.messageObject
    let popupMessage = `${message === 'file_message'
      ? `You got new file message from ${sender}`
      : `You got new message from ${sender}: ${message.length > 60 ? message.substr(0, 60) + '...' : message}`}`
    return (
      !this.state.instantHide &&
      <Wrapper show={this.state.showPopUp}>
        <Symbol name='icon-chat' />
        <MessageContainer onClick={() => window.location.replace(this.props.redirectTo + '/conversation/' + channelUrl)}>
          <label>{popupMessage}</label>
        </MessageContainer>
        <CloseButton onClick={() => this.instantHide()} >
          <span className='left' />
          <span className='right' />
        </CloseButton>
      </Wrapper>
    )
  }
}

export default MessengerPopUp
